import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useBreakpointsContext } from "@air/provider-media-query";
import { useFlags } from "launchdarkly-react-client-sdk";
import { memo } from "react";
import { PublicBoardEditCustomFieldsButton } from "~/_app/(public-board)/_components/PublicBoardEditCustomFieldsButton";
import { PublicBoardHeaderAncestors } from "~/_app/(public-board)/_components/PublicBoardHeaderAncestors";
import { PublicBoardHeaderCustomFields } from "~/_app/(public-board)/_components/PublicBoardHeaderCustomFields";
import { PublicBoardHeaderDescription } from "~/_app/(public-board)/_components/PublicBoardHeaderDescription";
import { PublicBoardHeaderTitle } from "~/_app/(public-board)/_components/PublicBoardHeaderTitle";
import { PublicBoardMobileShareButton } from "~/_app/(public-board)/_components/PublicBoardMobileShareButton";
import { PublicBoardMoreOptionsButton } from "~/_app/(public-board)/_components/PublicBoardMoreOptionsButton";
import { BoardHeader } from "~/_components/BoardHeader";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { canSeeAssetCustomFields } from "~/utils/permissions/assetPermissions";
export const PublicBoardHeader = /*#__PURE__*/ memo(()=>{
    const { permissions } = usePublicPermissions();
    const { isAboveMediumScreen } = useBreakpointsContext();
    const { mobileSearch: mobileSearchFlag } = useFlags();
    const canViewCustomFields = canSeeAssetCustomFields(permissions);
    return /*#__PURE__*/ _jsx(BoardHeader, {
        actions: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                canViewCustomFields && /*#__PURE__*/ _jsx(PublicBoardEditCustomFieldsButton, {}),
                !isAboveMediumScreen && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(PublicBoardMobileShareButton, {}),
                        /*#__PURE__*/ _jsx(PublicBoardMoreOptionsButton, {})
                    ]
                })
            ]
        }),
        ancestors: (isAboveMediumScreen || !mobileSearchFlag) && /*#__PURE__*/ _jsx(PublicBoardHeaderAncestors, {}),
        customFields: canViewCustomFields && /*#__PURE__*/ _jsx(PublicBoardHeaderCustomFields, {}),
        description: /*#__PURE__*/ _jsx(PublicBoardHeaderDescription, {}),
        title: /*#__PURE__*/ _jsx(PublicBoardHeaderTitle, {})
    });
});
PublicBoardHeader.displayName = "PublicBoardHeader";
